import {
  STATUS_FILTER_LABELS,
  STATUS_LABELS,
  resolveOrder,
  type ResourceStatus
} from '@/shared/lib/status'

export type QuizUiStatus = ResourceStatus

/* Quiz é masculino — o canônico já vem nessa forma, então não há override.
   Antes deste arquivo, `QUIZ_STATUS_LABELS.nova` dizia "Nova" enquanto o chip
   equivalente dizia "Disponíveis": a mesma chave com dois textos na mesma tela.
   Agora as duas tabelas saem da mesma fonte. */
export const QUIZ_STATUS_LABELS = STATUS_LABELS

export const QUIZ_SORT_PRIORITY = resolveOrder()

/* `new` (recência) não é `ResourceStatus` — ver `shared/lib/recency`. */
export type QuizFilterId =
  | 'all'
  | 'new'
  | Extract<ResourceStatus, 'available' | 'progress' | 'success' | 'locked'>

export const QUIZ_FILTERS: { id: QuizFilterId; label: string }[] = [
  { id: 'all', label: 'Todos' },
  { id: 'available', label: STATUS_FILTER_LABELS.available },
  { id: 'progress', label: STATUS_FILTER_LABELS.progress },
  { id: 'success', label: STATUS_FILTER_LABELS.success },
  { id: 'locked', label: STATUS_FILTER_LABELS.locked }
]
